import { render, staticRenderFns } from "./BenchmarkQuestionTable.vue?vue&type=template&id=906c8b8a&scoped=true&"
import script from "./BenchmarkQuestionTable.vue?vue&type=script&lang=js&"
export * from "./BenchmarkQuestionTable.vue?vue&type=script&lang=js&"
import style0 from "./BenchmarkQuestionTable.vue?vue&type=style&index=0&id=906c8b8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "906c8b8a",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})


/* hot reload */
if (module.hot) {
  var api = require("/builds/iaai/products/maturity-assessment-tool/mat-website/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('906c8b8a')) {
      api.createRecord('906c8b8a', component.options)
    } else {
      api.reload('906c8b8a', component.options)
    }
    module.hot.accept("./BenchmarkQuestionTable.vue?vue&type=template&id=906c8b8a&scoped=true&", function () {
      api.rerender('906c8b8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BenchmarkQuestionTable.vue"
export default component.exports